/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ApiEmail,
  ApiToken,
  BaseUrl,
  ChangeRequest,
  ContextConnection,
  ContextConnectionFilter,
  ContextConnectionLabel,
  ContextConnectionTestResult,
  ContextConnector,
  ContextConnectorSetup,
  ContextRecord,
  ContextRecordInput,
  ContextRecordType,
  ContextUsageSettings,
  EntityId,
  List,
  ProjectKeys,
  SiteChannelType,
  SiteFinding,
  SiteFindingAction,
  SiteFindingAutoResolution,
  SiteFindingOrderBy,
  SiteFindingPage,
  SiteFindingSeverity,
  SiteFindingState,
  SiteFindingStats,
  SiteFindingStatus,
  SiteFindingType,
  SiteQuestion,
  SiteQuestionAnswerRelevance,
  SiteQuestionAnswerResolution,
  SiteQuestionVisitorType,
  SiteScan,
  SiteScanStatus,
  SiteTopic,
  SiteTopicUsageSettings,
  SiteTriageFilterConnections,
  SiteTriageFilterQuestions,
  StatusMapping,
  Timestamp,
} from "./data-contracts";

/**
 * No description
 * @tags site-context
 * @name ListSiteContextRecords
 * @summary List all context records
 * @request GET:/orgs/{organizationId}/sites/{siteId}/context-records
 * @secure
 */

// @ts-ignore
export const listSiteContextRecords: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Filter context records by type. */
    type?: ContextRecordType;
    /** Filter context records by connector type. */
    connector?: ContextConnector;
    /** Filter context records by connection id. */
    connection?: string;
    /** Filter context records by associated site topic ID. */
    topic?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ContextRecord[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/context-records",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name UpsertSiteContextRecords
 * @summary Create or update context records
 * @request PUT:/orgs/{organizationId}/sites/{siteId}/context-records
 * @secure
 */

// @ts-ignore
export const upsertSiteContextRecords: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: ContextRecordInput[];
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/context-records",
  method: "put",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name GetSiteContextRecordById
 * @summary Get a context record
 * @request GET:/orgs/{organizationId}/sites/{siteId}/context-records/{siteContextRecordId}
 * @secure
 */

// @ts-ignore
export const getSiteContextRecordById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the context record */
    siteContextRecordId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ContextRecord;
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/context-records/{siteContextRecordId}",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name ListSiteScans
 * @summary List all site scans
 * @request GET:/orgs/{organizationId}/sites/{siteId}/scans
 * @secure
 */

// @ts-ignore
export const listSiteScans: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Filter scans by associated site topic ID. */
    topic?: string;
    /** Filter scans by status. */
    status?: SiteScanStatus;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteScan[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/scans",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name GetSiteScanById
 * @summary Get a site scan by ID
 * @request GET:/orgs/{organizationId}/sites/{siteId}/scans/{siteScanId}
 * @secure
 */

// @ts-ignore
export const getSiteScanById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site scan */
    siteScanId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteScan;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/scans/{siteScanId}",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists the quality issues GitBook's AI has identified on a site by comparing its content against real usage and external sources — content gaps, outdated or incorrect content, and broken or outbound links. Use this when asked to find, audit, or fix problems in a site's docs. Only findings with status "open" need work; "candidate" ones have not been confirmed yet. A "broken-link" finding is fixed by a redirect rather than a content edit: pass its `brokenLinkAction` to createSiteRedirect. Fix the rest by opening a change request with its `siteFindingId` set, so merging the change request resolves it.
 * @tags site-context
 * @name ListSiteFindings
 * @summary List documentation issues GitBook has found on a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/findings
 * @secure
 */

// @ts-ignore
export const listSiteFindings: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Filter findings by associated site topic ID. */
    topic?: string;
    /** Filter findings that reference the given site question ID as evidence. */
    question?: string;
    /** Filter findings by status. */
    status?: SiteFindingStatus;
    /** Filter findings by type. When multiple types are given, findings matching any of them are returned. */
    type?: SiteFindingType[];
    /** Filter link findings whose URL contains this text: the broken path of a `broken-link` finding, or the checked URL of an `outbound-link-error` one. Findings of any other type never match, so this narrows the list to link findings on its own. */
    url?: string;
    /** Filter findings by estimated severity. */
    severity?: SiteFindingSeverity;
    /** Filter findings by what GitBook did on its own to resolve them: `drafted` fixes wait for approval, `applied` ones were made live, `undone` ones were reversed by a person. */
    autoResolution?: SiteFindingAutoResolution;
    /**
     * Only return findings GitBook drafted or applied a fix for at or after this date. Combine with `autoResolution` and `status` to count recent automatic fixes.
     * @format date-time
     */
    autoResolvedAfter?: string;
    /** Filter findings that have at least one associated change request. */
    hasChangeRequests?: boolean;
    /** Filter link findings by where they stand, for example `awaiting-approval` for broken links with a redirect GitBook drafted. */
    state?: SiteFindingState;
    /** Filter findings by the source of their evidence. Each entry is either `connection:<connectionId>` (findings with at least one piece of evidence coming from the given connection) or `questions` (findings with at least one piece of evidence coming from a site question). When multiple entries are given, findings matching any of them are returned. */
    source?: (SiteTriageFilterQuestions | SiteTriageFilterConnections)[];
    /**
     * Only return findings last updated at or after this date.
     * @format date-time
     */
    updatedAfter?: string;
    /**
     * Only return findings last updated before this date.
     * @format date-time
     */
    updatedBefore?: string;
    /** Sort findings by the given field. */
    orderBy?: SiteFindingOrderBy;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteFinding[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/findings",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves the full detail of one documentation issue found by GitBook's AI. Use this after `listSiteFindings` to inspect a specific issue before deciding to fix, dismiss, or investigate it further.
 * @tags site-context
 * @name GetSiteFindingById
 * @summary Get details of a single documentation issue
 * @request GET:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}
 * @secure
 */

// @ts-ignore
export const getSiteFindingById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site finding */
    siteFindingId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteFinding;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists the change requests created to fix a documentation issue. Use this to check whether an issue already has a pending or merged fix before triggering a new one.
 * @tags site-context
 * @name ListChangeRequestsForSiteFinding
 * @summary List content fixes already proposed for a documentation issue
 * @request GET:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/change-requests
 * @secure
 */

// @ts-ignore
export const listChangeRequestsForSiteFinding: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site finding */
    siteFindingId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ChangeRequest[];
  };
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/change-requests",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Starts GitBook's AI on fixing a documentation issue directly: it drafts the content change and opens it as a change request for review, rather than editing content in place. This is the primary way to act on "fix issues/gaps/broken links in my docs" requests once `listSiteFindings` has surfaced the relevant findings. Processing is asynchronous; poll `listChangeRequestsForSiteFinding` for the resulting change request, then review and merge it with `submitOrMergeChangeRequest`.
 * @tags site-context
 * @name TriggerChangeRequestsForSiteFinding
 * @summary Fix a documentation issue by generating a change request
 * @request POST:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/change-requests
 * @secure
 */

// @ts-ignore
export const triggerChangeRequestsForSiteFinding: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site finding */
    siteFindingId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 202;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/change-requests",
  method: "post",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists the site pages a documentation issue relates to. Use this to locate which page(s) to edit when fixing an issue manually instead of via `triggerChangeRequestsForSiteFinding`.
 * @tags site-context
 * @name ListPagesForSiteFinding
 * @summary List the pages affected by a documentation issue
 * @request GET:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/pages
 * @secure
 */

// @ts-ignore
export const listPagesForSiteFinding: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site finding */
    siteFindingId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteFindingPage[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/pages",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists the questions end users asked GitBook's Ask-AI assistant that were used as evidence for a documentation issue. Use this to see what users actually wanted to know before deciding how to fix the issue.
 * @tags site-context
 * @name ListQuestionsForSiteFinding
 * @summary List the Ask-AI questions evidencing a documentation issue
 * @request GET:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/questions
 * @secure
 */

// @ts-ignore
export const listQuestionsForSiteFinding: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site finding */
    siteFindingId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteQuestion[];
  };
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/questions",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists the context records that GitBook's AI used as evidence for a documentation issue. Use this to see what real-world signal led to the finding before deciding how to fix it.
 * @tags site-context
 * @name ListRecordsForSiteFinding
 * @summary List the source content evidencing a documentation issue
 * @request GET:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/records
 * @secure
 */

// @ts-ignore
export const listRecordsForSiteFinding: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site finding */
    siteFindingId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ContextRecord[];
  };
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/records",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Applies one of the `actions` a finding lists, with the site permission it gives: resolve, dismiss or reopen it, act on a broken link's redirect, or reject the change request GitBook drafted for an outbound link. Returns 409 when the finding doesn't allow the action now.
 * @tags site-context
 * @name ApplySiteFindingAction
 * @summary Apply an action to a finding
 * @request POST:/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/actions
 * @secure
 */

// @ts-ignore
export const applySiteFindingAction: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site finding */
    siteFindingId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * An action that moves a finding to another state. A finding's `actions` lists the ones it allows.
     *   - `approve` makes the redirect GitBook drafted for a broken link live, which resolves the finding. A change request GitBook drafted for an outbound link is approved by merging it.
     *   - `reject` deletes the redirect GitBook drafted for a broken link; the finding stays open and GitBook won't draft a fix for it again. For an outbound link, it archives the change request GitBook drafted (`awaitingChangeRequest`) and unlinks every link it fixes. They are open again, marked `undone`, and GitBook won't draft a fix for them again.
     *   - `create-redirect` creates a redirect for a broken link's path with `createSiteRedirect`, prefilled with the suggestion; it resolves the finding.
     *   - `mark-resolved` resolves it. A broken link resolved this way has no redirect: visitors still get a 404.
     *   - `reopen` reopens a resolved finding. For a broken link, it deletes the live redirect at its path; for a fix GitBook applied, this undoes the fix and GitBook won't fix the link again.
     *   - `ignore` dismisses it.
     *   - `restore` reopens a dismissed finding.
     */
    action: SiteFindingAction;
  };
  RequestHeaders: {};
  ResponseBody: SiteFinding;
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/findings/{siteFindingId}/actions",
  method: "post",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns aggregate statistics about the documentation issues GitBook identified on a site. Accepts the same filters as `listSiteFindings`. Use this to answer "how healthy are my docs" before drilling into individual findings.
 * @tags site-context
 * @name GetSiteFindingStats
 * @summary Get a summary of documentation issues found on a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/stats/findings
 * @secure
 */

// @ts-ignore
export const getSiteFindingStats: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Filter findings by associated site topic ID. */
    topic?: string;
    /** Filter findings by status. */
    status?: SiteFindingStatus;
    /** Filter findings by type. When multiple types are given, findings matching any of them are returned. */
    type?: SiteFindingType[];
    /** Filter findings by estimated severity. */
    severity?: SiteFindingSeverity;
    /** Filter findings by what GitBook did on its own to resolve them: `drafted` fixes wait for approval, `applied` ones were made live, `undone` ones were reversed by a person. */
    autoResolution?: SiteFindingAutoResolution;
    /**
     * Only return findings GitBook drafted or applied a fix for at or after this date. Combine with `autoResolution` and `status` to count recent automatic fixes.
     * @format date-time
     */
    autoResolvedAfter?: string;
    /** Filter findings that have at least one associated change request. */
    hasChangeRequests?: boolean;
    /** Filter findings by the source of their evidence. Each entry is either `connection:<connectionId>` (findings with at least one piece of evidence coming from the given connection) or `questions` (findings with at least one piece of evidence coming from a site question). When multiple entries are given, findings matching any of them are counted. */
    source?: (SiteTriageFilterQuestions | SiteTriageFilterConnections)[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteFindingStats;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/stats/findings",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name ListSiteContextConnections
 * @summary List all context connections
 * @request GET:/orgs/{organizationId}/sites/{siteId}/context-connections
 * @secure
 */

// @ts-ignore
export const listSiteContextConnections: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ContextConnection[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/context-connections",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name CreateSiteContextConnection
 * @summary Create a context connection
 * @request POST:/orgs/{organizationId}/sites/{siteId}/context-connections
 * @secure
 */

// @ts-ignore
export const createSiteContextConnection: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: ContextConnectorSetup & {
    usageSettings?: ContextUsageSettings;
    /** Optional filter used to restrict which items are ingested from the source. Its meaning depends on the connector: it can be a tag, label, or an expression. When empty or omitted, all resolved items are ingested. */
    filter?: ContextConnectionFilter;
  };
  RequestHeaders: {};
  ResponseBody: ContextConnection;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/context-connections",
  method: "post",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name GetSiteContextConnectionById
 * @summary Get a context connection
 * @request GET:/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}
 * @secure
 */

// @ts-ignore
export const getSiteContextConnectionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the context connection */
    siteContextConnectionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ContextConnection;
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name UpdateSiteContextConnectionById
 * @summary Update a context connection
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}
 * @secure
 */

// @ts-ignore
export const updateSiteContextConnectionById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the context connection */
    siteContextConnectionId: string;
  };
  RequestQuery: {};
  RequestBody:
    | ContextConnectorSetup
    | {
        connector: "builtin:jira";
        /** Optional label for the connection */
        label?: ContextConnectionLabel;
        setupSettings: {
          /** Base URL of the Jira Cloud site, e.g. https://your-team.atlassian.net. */
          baseUrl: BaseUrl;
          /** Email of the Atlassian account whose API token is used. */
          apiEmail: ApiEmail;
          /** Atlassian API token used for outbound writes. Redacted when read back. Omit it when updating a connection to keep the stored token; required when the site URL or account email changes. */
          apiToken?: ApiToken;
          /** Projects where GitBook handles issues. Empty means all accessible projects. */
          projectKeys?: ProjectKeys;
          /** Jira status to move the linked issue to when the change request reaches a given status, e.g. `{ "merged": "Done" }`. A status left out is not synced. */
          statusMapping?: StatusMapping;
        };
      }
    | {
        usageSettings?: ContextUsageSettings;
        /** Optional label for the connection */
        label?: ContextConnectionLabel;
        /** Optional filter used to restrict which items are ingested from the source. Its meaning depends on the connector: it can be a tag, label, or an expression. When empty or omitted, all resolved items are ingested. */
        filter?: ContextConnectionFilter;
      };
  RequestHeaders: {};
  ResponseBody: ContextConnection;
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}",
  method: "patch",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name DeleteSiteContextConnectionById
 * @summary Delete a context connection
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}
 * @secure
 */

// @ts-ignore
export const deleteSiteContextConnectionById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the context connection */
    siteContextConnectionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}",
  method: "delete",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name SyncSiteContextConnection
 * @summary Trigger a sync for a context connection
 * @request POST:/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}/sync
 * @secure
 */

// @ts-ignore
export const syncSiteContextConnection: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the context connection */
    siteContextConnectionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 400;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}/sync",
  method: "post",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Verifies the stored credentials of a context connection against the external service, without changing anything. A failed verification is reported in the response body with `success` set to `false` rather than as an HTTP error. Connectors that have nothing to verify report `success: true`.
 * @tags site-context
 * @name TestSiteContextConnection
 * @summary Test a context connection's stored credentials
 * @request POST:/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}/test
 * @secure
 */

// @ts-ignore
export const testSiteContextConnection: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the context connection */
    siteContextConnectionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ContextConnectionTestResult;
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/context-connections/{siteContextConnectionId}/test",
  method: "post",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name ListSiteTopics
 * @summary List all topics
 * @request GET:/orgs/{organizationId}/sites/{siteId}/topics
 * @secure
 */

// @ts-ignore
export const listSiteTopics: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Filter stats to answers created at or after this timestamp. */
    from?: Timestamp;
    /** Filter stats to answers created at or before this timestamp. */
    to?: Timestamp;
    /** Filter stats by question relevance. */
    relevance?: SiteQuestionAnswerRelevance[];
    /** Filter stats by answer channel type. */
    channelType?: SiteChannelType[];
    /** Filter by whether a person or an AI agent asked the question. */
    visitorType?: SiteQuestionVisitorType[];
    /** Filter stats by answer resolution. */
    answered?: SiteQuestionAnswerResolution[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: SiteTopic[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/topics",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves a single topic of a site by its ID, including its label, its parent topic when it is a subtopic, its summary and usage settings, and its page, record, finding and Ask AI question counts. Use this when you have a topic ID and need the topic's label or its stats.
 * @tags site-context
 * @name GetSiteTopicById
 * @summary Get a topic
 * @request GET:/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}
 * @secure
 */

// @ts-ignore
export const getSiteTopicById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the topic */
    siteTopicId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteTopic;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}",
  method: "get",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-context
 * @name UpdateSiteTopicById
 * @summary Update a topic
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}
 * @secure
 */

// @ts-ignore
export const updateSiteTopicById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the topic */
    siteTopicId: string;
  };
  RequestQuery: {};
  RequestBody: {
    usageSettings: SiteTopicUsageSettings;
  };
  RequestHeaders: {};
  ResponseBody: SiteTopic;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}",
  method: "patch",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Permanently deletes every finding associated with a site topic, regardless of status. This is a bulk, irreversible cleanup operation — use `applySiteFindingAction` to resolve or dismiss individual issues instead unless the intent is to wipe every issue under a topic, for example when the topic itself is being removed.
 * @tags site-context
 * @name DeleteSiteTopicFindings
 * @summary Delete all documentation issues found under a topic
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}/findings
 * @secure
 */

// @ts-ignore
export const deleteSiteTopicFindings: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the topic */
    siteTopicId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/topics/{siteTopicId}/findings",
  method: "delete",
  streaming: false,
  tags: ["site-context"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
